import Style from "./PopupEvent.module.css";
import parse from "html-react-parser";
import { baseURL } from "../../Api/config";
import { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { useLocation, useNavigate } from "react-router-dom";
import { singleEvent } from "../../Api/services";

const PopupEvent = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const location = useLocation();
  // const eventId = location.state;
  { /* Added by Yogen on 15/06/2025 
      Reason To display Event Type */}
  const { id: eventId, eventType } = location.state || {};
  {/* End by Yogen on 15/06/2025 
      Reason To display Event Type */}
  const fetchEventsDetails = async () => {
    try {
      const response = await singleEvent(eventId);
      setSelectedEvent(response.event_details);
    } catch (error) {
      console.error("Error fetching events details:", error);
    }
  };

  useEffect(() => {
    // window.scrollTo(0, 0);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Events", path: "/events" },
      { name: "Event", path: "/event" },
    ]);

    fetchEventsDetails();
  }, []);

  return (
    <div className={Style.mainContainer}>
      <NavigationPath navigationPathArray={navigationPath} />

      {/* <div className={Style.uITitle}>Event</div> */}
      <div className={Style.uITitle}>{eventType}</div>
      {selectedEvent ? (
        <div className={Style.popupContainer}>
          <div className={Style.popupCards}>
            <div className={Style.popupTitle}>
              {selectedEvent?.title && parse(selectedEvent.title)}
            </div>

            <div className={Style.popupDescription}>
              {selectedEvent?.description && parse(selectedEvent.description)}
            </div>
            <div className={Style.popupImageField}>
              {selectedEvent?.event_image ? (
                <div className={Style.popupImages}>
                  <img
                    src={baseURL + selectedEvent?.event_image}
                    className={Style.popupImage}
                  />
                </div>
              ) : null}
              {selectedEvent?.event_image2 ? (
                <div className={Style.popupImages}>
                  <img
                    src={baseURL + selectedEvent?.event_image2}
                    className={Style.popupImage}
                  />
                </div>
              ) : null}
              {selectedEvent?.event_image3 ? (
                <div className={Style.popupImages}>
                  <img
                    src={baseURL + selectedEvent?.event_image3}
                    className={Style.popupImage}
                  />
                </div>
              ) : null}
              {selectedEvent?.event_image4 ? (
                <div className={Style.popupImages}>
                  <img
                    src={baseURL + selectedEvent?.event_image4}
                    className={Style.popupImage}
                  />
                </div>
              ) : null}
              {selectedEvent?.event_image5 ? (
                <div className={Style.popupImages}>
                  <img
                    src={baseURL + selectedEvent?.event_image5}
                    className={Style.popupImage}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PopupEvent;
